var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-container grey-background"},[_c('the-navbar'),(_vm.isLoading)?_c('b-loading',{staticClass:"fill-screen",attrs:{"is-full-page":true,"can-cancel":false,"active":true}}):_c('project')],1)}
var staticRenderFns = []

export { render, staticRenderFns }